'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002493 from "./presto.-Presto-Router$$anon$93.js";
import * as $j_presto$002e$002dTest$002dPage$0024 from "./presto.-Test-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$92() {
  this.bqk = null;
  this.bqc = null;
  this.bqd = false;
  this.bql = null;
  this.bqm = false;
  this.bqp = null;
  this.bqi = null;
  this.bqj = false;
  this.bqe = null;
  this.bqf = false;
  this.bqg = null;
  this.bqh = false;
  this.bqn = false;
  this.bqo = false;
  this.bqk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bqp = "TestPage";
}
export { $c_Lpresto_PrestoRouter$$anon$92 as $c_Lpresto_PrestoRouter$$anon$92 };
$p = $c_Lpresto_PrestoRouter$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$92;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$92() {
}
export { $h_Lpresto_PrestoRouter$$anon$92 as $h_Lpresto_PrestoRouter$$anon$92 };
$h_Lpresto_PrestoRouter$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bqk;
});
$p.M = (function() {
  if ((!this.bqd)) {
    this.bqc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bqd = true;
  }
  return this.bqc;
});
$p.O = (function() {
  if ((!this.bqm)) {
    this.bql = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bqm = true;
  }
  return this.bql;
});
$p.D = (function() {
  return this.bqp;
});
$p.t = (function() {
  if ((!this.bqj)) {
    this.bqi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqj = true;
  }
  return this.bqi;
});
$p.N = (function() {
  if ((!this.bqf)) {
    this.bqe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqf = true;
  }
  return this.bqe;
});
$p.Q = (function() {
  if ((!this.bqh)) {
    this.bqg = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002493.$c_Lpresto_PrestoRouter$$anon$93();
    this.bqh = true;
  }
  return this.bqg;
});
$p.v = (function() {
  if ((!this.bqo)) {
    this.bqn = false;
    this.bqo = true;
  }
  return this.bqn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee583) => ((p) => \u03b4scrutinee583))($j_presto$002e$002dTest$002dPage$0024.$m_Lpresto_TestPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$92, "presto.PrestoRouter$$anon$92", ({
  Pa: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$92 as $d_Lpresto_PrestoRouter$$anon$92 };
//# sourceMappingURL=presto.-Presto-Router$$anon$92.js.map
